import React from 'react';
import { Drawer as AntdDrawer } from 'antd';
import type { DrawerProps as AntdDrawerProps } from 'antd';
import { resolvePortalContainer } from '../_internal/portalContainer';
import './Drawer.css';

export interface WxbDrawerProps extends AntdDrawerProps {}

export const WxbDrawer: React.FC<WxbDrawerProps> = ({
  className = '',
  title,
  id,
  // 默认挂进当前全屏元素(无全屏时为 document.body);调用方显式传则尊重其值。
  getContainer = resolvePortalContainer,
  ...props
}) => {
  const generatedId = React.useId().replace(/:/g, '');
  const titleId = `wxb-drawer-title-${generatedId}`;
  const hasTitle = title !== undefined && title !== null && title !== false;
  const titleRef = React.useRef<HTMLHeadingElement | null>(null);
  const dialogRef = React.useRef<HTMLElement | null>(null);
  const assignTitleRef = React.useCallback((node: HTMLHeadingElement | null) => {
    titleRef.current = node;
    const dialog = node?.closest<HTMLElement>('[role="dialog"]');
    if (!dialog) return;
    dialogRef.current = dialog;
    dialog.setAttribute('aria-labelledby', titleId);
  }, [titleId]);

  React.useLayoutEffect(() => {
    const dialog = titleRef.current?.closest<HTMLElement>('[role="dialog"]') ?? dialogRef.current;
    if (!dialog) return;
    dialogRef.current = dialog;
    if (hasTitle) dialog.setAttribute('aria-labelledby', titleId);
    else dialog.removeAttribute('aria-labelledby');
  }, [hasTitle, props.open, props.visible, titleId]);

  return (
    <AntdDrawer
      className={`wxb-drawer ${className}`}
      getContainer={getContainer}
      id={id}
      title={hasTitle ? <h2 ref={assignTitleRef} id={titleId} className="wxb-drawer-title">{title}</h2> : title}
      {...props}
    />
  );
};
